// utils/gridOperations.js

import {addPosition} from "@dashboard/services/apiService";

export const handleAddPosition = (
    GUIInstrument,
    setLayouts,
    tabID,
    tick,
    setCurrentlyHeldPositions,
    posGridlayouts,
    setPosGridlayouts,
    PosGridTabID
) => {
    // Extract tradingSymbol and instrumentToken from GUIInstrument
    const tradingSymbol = GUIInstrument.tradingsymbol;
    const instrumentTokenValue = GUIInstrument.instrumentToken;
    const exchangeNameValue = GUIInstrument.exchange;
    const exchangeTokenValue = GUIInstrument.exchangeToken;

    // Get today's date in the format yyyy-MM-dd
    const todayDate = new Date().toISOString().split('T')[0]; // yyyy-MM-dd format

    // Create the position object using tick.lastTradedPrice for avgBuyPrice and add today's date
    const position = {
        tradingsymbol: tradingSymbol,
        instrumentToken: instrumentTokenValue,
        exchange: exchangeNameValue,
        exchangeToken: exchangeTokenValue,
        avgBuyPrice: tick.lastTradedPrice, // Assign lastTradedPrice from TickContext to avgBuyPrice
        date: todayDate,  // Add today's date in yyyy-MM-dd format
        tabID: tabID
    };

    // Call addPosition to persist the position in the backend or other logic
    addPosition(position);
    /*setSubscriptionToDetails(instrumentTokenValue);*/
    /*updateTokenSubscriptionWithKite(instrumentTokenValue,PosGridTabID);*/
    // Update the currentlyHeldPositions state by adding the new position
    setCurrentlyHeldPositions(prevPositions => [...prevPositions, position]);

    // Update the posGridlayouts by adding a new layout for the new position
    const newLayout = {
        i: `${PosGridTabID}-${instrumentTokenValue}`,  // Unique key based on tabID and instrumentToken
        x: 0,
        y: posGridlayouts.length,  // Set the new layout at the next available row
        w: 12,
        h: 1,
    };

    // Update the layout by appending the new layout entry
    setPosGridlayouts(prevLayouts => [...prevLayouts, newLayout]);
};
